import React, { useRef, useEffect } from 'react';
import { PUBLIC_IMG_URL } from '../../../../lib/endpoints';

export default function LandingBanner({ showContactSales }) {
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.muted = true;
            videoRef.current.play().catch(() => {});
        }
    }, []);

    return (
        <section className="lp-hero">
            <div className="lp-hero__content">
                <h1 className="lp-hero__title">
                    The Leading Private Capital Data Platform
                </h1>
                <p className="lp-hero__subtitle">
                    <b>Verified VC &amp; PE data </b> across MENA, Africa, Turkey, Pakistan and
                    Southeast Asia — powering smarter investment decisions, faster due
                    diligence, and deeper market insight.
                </p>
                <div className="lp-hero__actions">
                    <button className="btn btn-main btn-lg" onClick={showContactSales}>
                        Speak to Our Team
                    </button>
                    <a className="btn lp-btn-outline btn-lg" href="/research">
                        View Latest Report
                    </a>
                </div>
            </div>

            <div className="lp-hero__Video">
                <video
                    ref={videoRef}
                    src={`${PUBLIC_IMG_URL}/anonymous-landing-page/MAGNiTT 3-3-2026 edited (850).mp4`}
                    autoPlay
                    muted
                    playsInline
                    controls
                ></video>
            </div>
        </section>
    );
}
